import { cn } from "@yardzen/ui/lib/utils";

export function PageActions({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-1 flex-row items-end justify-center gap-4 sm:flex-initial sm:items-center",
        className,
      )}
    >
      {children}
    </div>
  );
}
